import { assign, ContextFrom } from 'xstate';

import { subscriptionModel } from '../../models';
import { UpdateSubscription, GetSubscriptionDetails } from './types';
import { getUniqueCoupons } from './utils';

export const createSubscriptionMachine = (
  defaultContext: Partial<ContextFrom<typeof subscriptionModel>> = {}
) =>
  subscriptionModel.createMachine({
    id: 'subscription',
    predictableActionArguments: true,
    context: {
      ...subscriptionModel.initialContext,
      ...defaultContext,
    },
    initial: 'idle',
    states: {
      idle: {
        on: {
          GET_SUBSCRIPTION_DETAILS: 'loadingSubscriptionDetails',
        },
      },
      loadingSubscriptionDetails: {
        invoke: {
          src: 'getSubscriptionDetails',
          onDone: {
            target: 'ready',
            actions: assign((_, event: GetSubscriptionDetails) => {
              return {
                ...event.data,
              };
            }),
          },
          onError: {
            target: 'error',
            actions: 'setError',
          },
        },
      },
      ready: {
        on: {
          ADD_COUPON: 'addingCoupon',
          GET_SUBSCRIPTION_DETAILS: 'loadingSubscriptionDetails',
          ADD_ANOTHER_COUPON: 'couponAdded',
        },
      },
      addingCoupon: {
        invoke: {
          src: 'addCoupon',
          onDone: {
            target: 'couponAdded',
            actions: assign((ctx, event) => {
              return {
                ...ctx,
                balanceInCents: event.data.subscriptionBalanceInCents,
                currentBillingAmountInCents:
                  event.data.subscriptionCurrentBillingAmountInCents,
                coupons: getUniqueCoupons([...ctx.coupons, event.data]),
                addedCoupon: event.data,
              };
            }),
          },
          onError: {
            actions: assign((ctx, event) => {
              return {
                ...ctx,
                error: event.data.errorCode,
              };
            }),
            target: 'error',
          },
        },
      },
      couponAdded: {
        on: {
          ADD_ANOTHER_COUPON: {
            target: 'ready',
            actions: assign((ctx) => {
              return {
                ...ctx,
                addedCoupon: null,
              };
            }),
          },
          GET_SUBSCRIPTION_DETAILS: 'loadingSubscriptionDetails',
        },
      },
      error: {
        on: {
          ADD_COUPON: {
            target: 'addingCoupon',
            actions: assign((ctx) => {
              return {
                ...ctx,
                error: null,
              };
            }),
          },
        },
      },
    },
    on: {
      UPDATE_SUBSCRIPTION: {
        actions: assign((ctx, event: UpdateSubscription) => {
          return {
            ...ctx,
            ...event.data,
          };
        }),
      },
    },
  });
